import React from "react";
export default class CustomInput extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            value:(this.props.value)?this.props.value:"",
            errorClass:""
        }
        //this.validState = this.validate();
        this.pattern = this.props.pattern;
    }
    onChangeHandler(event){
        if(this.state.errorClass == "error")
            this.validate(event.target.value);
        this.setState({value: event.target.value});
    }
    onBlurHandler(){
        this.validate(this.state.value);
    }
    isNumber(){
        return this.props.type == "number";
    }
    isWithInLimits(value){
        if(this.props.upperLimit && parseFloat(value) > parseFloat(this.props.upperLimit))
            return false;
        if(this.props.lowerLimit && parseFloat(value) < parseFloat(this.props.lowerLimit))
            return false;
        return true;
    }
    validate(value){
        if(    ( this.isRequired() && this.isUnset())
            || ( !this.isUnset() && !this.matchesPattern(value))
            || ( this.isNumber() && !this.isWithInLimits(value))
           // || ( this.isConfirmation() && !this.isConfirmationMatch(value))
            || (this.hasCustomValidityTest() && !this.passesValidityTest())
        ) {

            this.setValidState(false);
            return false;
        }
        this.setValidState(true);
        return true;
    }
    setValidState(valid){
        if(valid){
            this.setState({
                isValid : true,
                errorClass : ""
            });
            this.validState = true;
        }else {
            this.setState({
                isValid: false,
                errorClass: "error"
            });
            this.validState = false;
        }
    }
    isValid(){
        //return this.validState;
        return this.validate(this.state.value);
    }
    passesValidityTest(){
        return this.props.validityTest();
    }
    hasCustomValidityTest(){
        return typeof this.props.validityTest === 'function'
    }
    matchesPattern(value){
        if(this.props.type){
            switch (this.props.type){
                case "email":
                    this.pattern = '[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$';
                    break;
            }
        }
        if(!this.pattern)
            return true;
        //return this.state.value.match(this.pattern);
        //console.log("this.pattern.test(this.state.value);", this.pattern.test(this.state.value));
        let regEx = new RegExp(this.pattern);
        return regEx.test(value);
    }
    isRequired(){
        return this.props.required;
    }
    isUnset(){
        return this.state.value == "";
    }
    // isConfirmation(){
    //     console.log("CONFIRMATION ", this.props.confirmation)
    //
    //     return (typeof this.props.confirmation !== 'undefined');
    // }
    // isConfirmationMatch(value){
    //     console.log("CONFIRMATION MATCH", this.props.confirmation.state.value)
    //     return (this.props.confirmation.state.value==value);
    // }

    render() {
        return (
            <div className= {"custom-input "+this.state.errorClass}>
                <label for={this.props.customRef}  >{this.props.label}</label>

                <input
                    ref= {this.props.customRef}
                    placeholder= {this.props.placeholder}
                    type={this.props.type}
                    onChange={this.onChangeHandler.bind(this)}
                    onBlur={this.onBlurHandler.bind(this)}
                    value = {this.state.value}

                />
                <span className = "error-inline">{this.props.errorMessage}</span>

            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/common/components/CustomInput.jsx